<template>
  <div class="home">
    <v-header v-if="notapp" :go-back="true" :if-login="islogin" :mine='true'></v-header>
   	<addpetType v-if="selpetType" @petsN='getpetType'></addpetType>
   	<v-introduction v-if="isintroduction" @introductC="introductClose"></v-introduction>
   	<div class="allinfo">
    	<div class="title" ref="title">
	    	<ul>
	    		<p v-if="pagestatu == 1000" @click="showintroduct"><img src="../../../static/img/account2/introduction.png" alt="">{{$t('introduction.sure')}}</p>
	    		<li v-if="pagestatu == 1000">{{$t('petstatus.petinfo')}}</li>
	    		<li v-if="pagestatu == 1001">{{$t('petstatus.petlookafter')}}</li>
	    		<li v-if="pagestatu == 1002">{{$t('petstatus.petmissing')}}</li>
	    		<li v-if="pagestatu == 1003">{{$t('petstatus.petfinding')}}</li>
	    	</ul>
    	</div>
		  <div class="petinfo">
		    <div class="petinfo-main">
		      <div>
		        <div class="head_img" v-show="!ifedit">
		          <img :src="portrait" style="margin: auto;display: block;">
		        </div>
		        <div class="head_img" v-show="ifedit">
		          <img
		            :src="imgflag?avatar:avatar1"
		            @click.stop="uploadHeadImg"
		            style="margin: auto;display: block;"
		            v-show="isshow"
		          >
		          <canvas
		            ref="can"
		            v-show="showflag1"
		            style="width:80px;height:80px;margin: auto;display: block;border-radius: 50%;"
		            @click.stop="uploadHeadImg"
		          ></canvas>
		          <input type="file" accept="image/*" @change="handleFile" class="hiddenInput">
		        </div>
		        <div class="pet">
		          <ul>
		            <li>
		              <span class="petNewsIcon"><img src="../../../static/img/account2/petNick.png" alt=""></span>
		              <p class="infoBox" v-show="!ifedit">{{petname}}</p>
		              <el-input
		                :value="petname"
		                @input="changename"
		                v-model='petname'
		                @change="Verificationname"
		                maxlength="12"
		                v-show="ifedit"
		                :placeholder="$t('addpet.petName')" 
		                @blur.prevent="lossblur()"
		              ></el-input>
		              <span class="danger" v-show="flag6">{{$t('addpet.have')}}</span>
		            </li>
		            <li>
			            <span  class="petNewsIcon" @click="selpetsType(isable)" style="width:100%;"><img src="../../../static/img/account2/petType.png" alt=""></span>
			            <p v-show="!ifedit">{{petType}}</p>
			            <el-input v-model='petbelong' :value="petType" :placeholder="$t('addpet.petType')" maxlength="8" readonly v-show="ifedit" @change="Verificationbelong" @input="changepetbelong" ></el-input>
			            <p class="danger" v-show='flag3'>{{$t('addpet.enterchinese')}}</p>
			            <p class="danger" v-show='flag7'>{{$t('addpet.notpetType')}}</p>
			        	</li>
		            <li>
		              <span class="petNewsIcon"><img src="../../../static/img/account2/sex.png" alt=""></span>
		              <p v-show="!ifedit">{{value}}</p>
		              <div class="selectsex" v-show="ifedit">
		                <el-select v-model="value" :placeholder="$t('addpet.sex')" ref='sex'>
		                  <el-option
		                    v-for="item in options"
		                    :key="item.value"
		                    :label="item.label"
		                    :value="item.value"
		                  ></el-option>
		                </el-select>
		              </div>
		            </li>
		          </ul>
		        </div>
		      </div>
		    </div>
    		<div class="lostsign" v-if="lostsign">
        	<img src="../../../static/img/petlosted.png" alt="" />
        	<li>
        		<span v-for="item in losttime.slice(0,10)">{{item}}</span>
        	</li>
        </div>
		  </div>
		  
		<div class="mynews">
      <div class="new">
        <span class="title" v-show="false">{{$t('mynews.masternews')}}</span>
			<div class="news">
				<div class="pos"><span><img src="../../../static/img/account2/nick.png" alt=""></span>
					<input :disabled="isable" @blur.prevent="lossblur()" v-model="nc" maxlength="12" ref='name'  :placeholder="$t('mynews.mastername')" >
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/email.png" alt=""></span>
					<input :disabled="isable" v-model="em" @blur.prevent="lossblur()" :placeholder="$t('mynews.masteremail')" >
				</div>
        		<p class="denger" v-show="flag3">{{$t('forgetpassword.NotEmail')}}</p>
						<p class="denger" v-show="flag4">{{$t('forgetpassword.FalseEmail')}}</p>
				<div class="pos"><span><img src="../../../static/img/account2/phone.png" alt=""></span>
					<input :disabled="isable" v-model="phone" @blur.prevent="lossblur()" :placeholder="$t('mynews.masterphone')" > 
				</div>
        		<p class="denger" v-show="flag5">{{$t('forgetpassword.FalsePhone')}}</P>
        		<p class="denger" v-show="flag7">{{$t('forgetpassword.NotPhone')}}</P>
				<div class="pos"><span><img src="../../../static/img/account2/addr.png" alt=""></span>
					<input :disabled="isable" v-model="adr" @blur.prevent="lossblur()" :placeholder="$t('mynews.masteradr')" >
				</div>
			</div>
      </div>
		</div>
    <el-button v-if="activations" type="primary" style='margin:50px auto;display: block;width: 80%;' @click='save'>{{$t('activation.sure')}}</el-button>
    </div>
  </div>
</template>
<script >
import EXIF from "exif-js/exif.js";
import { getDevices } from "../../deviceApi/index.js";
import header from "../../components/header";
import store from "../../store/store.js";
import addpetType from "../myAccount/addpetType"
import lostpetinfo from "../myAccount/lostpetinfo";
import choosePet from "../../components/choosePet";
import adddeviceType from "../home/adddeviceType";
import introduction from "../login/introduction";
import scanningrecord from "../login/scanningrecord";
import { getLoginUser} from "../../api/index.js";
import { bind,add_pet,bind_pet,updateBasicInfo,getuserinfo } from "../../apiNew/index.js";
import Qs from "qs";
export default {
  name: "activation",
  data() {
    return {
    	lang:localStorage.getItem('locale'),
      islogin: true,
      infos: "",
      notapp:true,
      loginsuccess: false,
      loginshowflag: true,
      getToken: sessionStorage["token"],
      imei: "",
      activations:true,//激活按钮
      losttime:[],
      lostsign:false,//走失标志
      lostpetinfos:false,//走失宠物信息组件
      lostPlace:"",//默认走失地点
      isintroduction:false,//简介组件
      addDeviceBtn: false,
      deviceCode: "", //获得点击的设备devicedCode
      pagestatu:1000,//页面登录状态属性
      ifedit: true,//宠物信息是否可以编辑
      isable:false,//主人信息输入框
      petname: "",
      petType: "",
      gender: "",
      value: "",
      selpetType: false,//品种选择
      petbelong: "",
      portrait: "",
      portrait1: "",
      height:1,
      weight:1,
      birthday:"2019-07-01",
      color:"white",
      character:"good",
      petId:"",
      Id:"",
      nc: "",
      em: "",
      phone: "",
      adr: "",
      options: [
        {
          value: this.$t("prompt.boy"),
          label: this.$t("prompt.boy")
        },
        {
          value: this.$t("prompt.girl"),
          label: this.$t("prompt.girl")
        }
      ],
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6:false,
      flag7: false,
      flag8: false,
      flag9: false,
      flag10: false,
      flag11: false,
      scrollY:0,
      showflag: false,
      showflag1: false,
      isshow: true,
      imgflag: false,
      avatar: "",
      avatar1: require("../../../static/img/headerbg.png"),
    };
  },
  mounted() { 
		this.ready();
  },
  created() {
  	if(localStorage.fromapp){//是否在app内打开
  		this.notapp=false;
  	}
    //查询本地是否有token，有则自动登录，若没有则检查session是否
		let accessToken = this.GetQueryString("accessToken");
		localStorage.setItem('token',accessToken);
		this.$store.commit("set_token", accessToken);
		let id = this.GetUrlParam("deviceCode");
		localStorage.setItem('codeId',id);
		this.getuserinfo();
    var geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(
      function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          // console.log(r.point);
          sessionStorage.setItem("lng", r.point.lng);
          sessionStorage.setItem("lat", r.point.lat);
        } else {
          alert("failed" + this.getStatus());
        }
      },
      {
        enableHighAccuracy: true
      }
    );
    localStorage.removeItem('publishId'); 
  },
  watch:{
 			petbelong(newvalue, oldvalue){
        this.$nextTick(function() {
				localStorage.setItem('petbelong',newvalue);
				})
      },
 			petname(newvalue, oldvalue){
 				let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.petname=	oldvalue;	
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('petname',newvalue);
				})
     },
     value(newvalue, oldvalue){
        this.$nextTick(function() {
					localStorage.setItem('value',newvalue);
				})
     },
     em(newvalue, oldvalue){
     	 	let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.em=	oldvalue;	
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('em',newvalue);
				})
     },
     phone(newvalue, oldvalue){
     	  let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.phone=	oldvalue;	
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('phone',newvalue);
				})
     },
     adr(newvalue, oldvalue){
     		let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.adr=	oldvalue;	
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('adr',newvalue);
				})
     },
     nc(newvalue, oldvalue){
     		let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.nc=	oldvalue;	
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('nc',newvalue);
				})
     }
  },
  methods: {
//====过滤表情和特殊字符=====
    filter(substring){
		    if(substring){
		        for ( var i = 0; i < substring.length; i++) {
		            var hs = substring.charCodeAt(i);
		            if (0xd800 <= hs && hs <= 0xdbff) {
		                if (substring.length > 1) {
		                    var ls = substring.charCodeAt(i + 1);
		                    var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
		                    if (0x1d000 <= uc && uc <= 0x1f77f) {
		                        return true;
		                    }
		                }
		            } else if (substring.length > 1) {
		                var ls = substring.charCodeAt(i + 1);
		                if (ls == 0x20e3) {
		                    return true;
		                }
		            } else {
		                if (0x2100 <= hs && hs <= 0x27ff) {
		                    return true;
		                } else if (0x2B05 <= hs && hs <= 0x2b07) {
		                    return true;
		                } else if (0x2934 <= hs && hs <= 0x2935) {
		                    return true;
		                } else if (0x3297 <= hs && hs <= 0x3299) {
		                    return true;
		                } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030
		                    || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b
		                    || hs == 0x2b50) {
		                    return true;
		                }
		            }
		        }
		    }
		},
//获取url参数=========
  	GetQueryString(name){
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		},
//绑定用户=========
		bind(){
					let id =localStorage.codeId
					var params = Qs.stringify({
						code:id,
					});
					bind(params)
			    .then(res => {
						//console.log("绑定设备返回数据：",res);
			      if (res.data.header.status == 1000) {
							console.log('绑定设备成功！')
							this.add_pet();//添加宠物
			      }else{
				      this.$alert("<p>" + res.data.header.message + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
			      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
//添加宠物========
		add_pet(){
					var gender;
					if(this.value=='公'||this.value=='boy'){
						gender='male'
					}else{
						gender='female'
					}
					var params = Qs.stringify({
							name: this.petname,
	            height: this.height,
	            weight: this.weight,
	            birthTime: this.birthday,
	            petType: this.petbelong,
	            color: this.color,
	            gender: gender,
	            portrait: this.portrait,
	            character: this.character
					});
					add_pet(params)
			    .then(res => {
							//console.log("添加宠物返回数据：",res);
              if (res.data.header.status == 1000) {
                this.ifedit = false;
                this.portrait = res.data.data.portrait;
                this.petId = res.data.data.petId;
                this.Id = res.data.data.id;
 								localStorage.setItem('Id',this.Id);
                this.bind_pet();//绑定宠物
              }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });	
		},
//绑定宠物=======
		bind_pet(){
					let id =localStorage.codeId//获取吊牌id
					var params = Qs.stringify({
					    deviceCode:id,
         			petId:this.petId,	
					});
					bind_pet(params)
			    .then(res => {
						//console.log("绑定宠物返回数据：",res);
			      if (res.data.header.status == 1000) {
							console.log('绑定宠物成功！')
							 this.updateBasicInfo();//更新主人基本信息
			      }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
	    
		},
//修改用户基本信息====
		updateBasicInfo(){
					var params = Qs.stringify({
						nickname : this.nc,
		  			email : this.em,
		  			mobile : this.phone,
		  			address : this.adr,   
		  			sex:"0",
					});
					updateBasicInfo(params)
			    .then(res => {
						//console.log("修改用户返回数据：",res);
			      if (res.data.header.status == 1000) {
						let code = this.GetUrlParam("deviceCode");
    				localStorage.setItem('codeId',code);
    				localStorage.setItem('token',localStorage.token);
    				this.$alert("<p>" + this.$t("activation.success") + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
								});
						//this.$router.replace('/showInformation?accessToken='+localStorage.token+'&deviceCode='+code)
						window.location.href='/showInformation?accessToken='+localStorage.token+'&deviceCode='+code;
			      }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
//点击激活时保存信息=========
  	save(){
  		if(this.petname==''){
  			this.$alert("<p>" + this.$t("addpet.entername") + "</p>", {
				confirmButtonText: this.$t("prompt.sure"),
				dangerouslyUseHTMLString: true
				});
				return false;
			}else{
				var reg = /^[0-9a-zA-Z\u4e00-\u9fa5 ]+$/;
				if(!reg.test(this.petname)){
					this.$alert("<p>" + this.$t("prompt.contentInteval") + "</p>", {
					confirmButtonText: this.$t("prompt.sure"),
					dangerouslyUseHTMLString: true
					});
					return false;
				}
  		}
  		if(this.petbelong==''){
  			this.petType = ''
  		}else{
  			this.petType = this.petbelong;//获取品种
  		}
  		if(this.value==''){
  			this.gender = ''
  		}else{
  			this.gender = this.value;
  		}
  		if(this.portrait1 == ''){
  			this.portrait = ''
  		}else{
  			this.portrait = this.portrait1;//宠物头像
  		}
			if(this.nc=='' || this.nc=='undefined' || this.nc==undefined){
				this.$alert("<p>" + this.$t("mynewsedit.EnterMastername") + "</p>", {
				confirmButtonText: this.$t("prompt.sure"),
				dangerouslyUseHTMLString: true
				});
				return false;
			}else{
				this.nickname = this.nc;
			}
			if(this.em==''){
				this.email=''
			}else{
//				var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
//				if(!reg.test(this.em)){
//					this.$alert("<p>" + this.$t("forgetpassword.FalseEmail") + "</p>", {
//					confirmButtonText: this.$t("prompt.sure"),
//					dangerouslyUseHTMLString: true
//					});
//					return false;
//				}
				this.email = this.em;
			}
		if(this.phone==''){
			this.mobile=''
		}else{
//			let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
//	  		if(!reg1.test(this.phone)){
//					this.$alert("<p>" + this.$t("forgetpassword.FalsePhone") + "</p>", {
//					confirmButtonText: this.$t("prompt.sure"),
//					dangerouslyUseHTMLString: true
//					});
//					return false;
//				}
			this.mobile = this.phone;
		}
  		if(this.adr==''){
  			this.address=''
  		}else{
  			this.address = this.adr;
  		}
			this.bind();//绑定设备
  	},
//=======获取url指定参数
		GetUrlParam(paraName){
		　　　　var url = document.location.toString();
		　　　　var arrObj = url.split("?");
		　　　　if (arrObj.length > 1) {
		　　　　　　var arrPara = arrObj[1].split("&");
		　　　　　　var arr;
		　　　　　　for (var i = 0; i < arrPara.length; i++) {
		　　　　　　　　arr = arrPara[i].split("=");
		　　　　　　　　if (arr != null && arr[0] == paraName) {
		　　　　　　　　　　return arr[1];
		　　　　　　　　}
		　　　　　　}
		　　　　　　return "";
		　　　　}
		　　　　else {
		　　　　　　return "";
		　　　　}
		　　},
//获取当前时间
	  	getNowFormatDate() {	  
		  	var date = new Date();
		  	var year = date.getFullYear();
		  	var month = date.getMonth() + 1;
		  	var strDate = date.getDate();
		  	if (month >= 1 && month <= 9) {
		   	 month = "0" + month;
		  	}
		  	if (strDate >= 0 && strDate <= 9) {
		    strDate = "0" + strDate;
		  	}
		  	var h =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +":";
      	var m =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      	var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
		  	var currentdate = year + '-' + month + '-' + strDate +' ' + h + m + s;
		  	this.losttime = currentdate;
		  	//console.log('发布丢失的当前时间：',this.losttime)
		  	localStorage.setItem('lossTime',this.losttime)
		},
//发布走失地点定位
    ready: function() {
        var th = this;
        var map = new BMap.Map("allmap");
        var geolocation = new BMap.Geolocation();
        var geoc = new BMap.Geocoder();
        geolocation.getCurrentPosition(
            function(r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    th.lng = r.point.lng;
                    th.lat = r.point.lat;
                    geoc.getLocation(r.point, function(rs) {
                        //addressComponents对象可以获取到详细的地址信息
                        var addComp = rs.addressComponents;
                        var site =
                            addComp.province +
                            addComp.city +
                            addComp.district +
                            addComp.street +
                            addComp.streetNumber;
                        th.place = site;
                        th.lostPlace = site;
                    });
                } else {
                    alert("failed" + this.getStatus());
                }
            },
            { enableHighAccuracy: true }
        );
    },
//====获取用户信息==========
		getuserinfo(){
			var params = Qs.stringify({
					    params:'*',
					});
					getuserinfo(params)
			    .then(res => {
						//console.log("获取用户信息：",res);
			      if (res.data.header.status == 1000) {
							this.nc= res.data.data.nickname;
							this.em=res.data.data.email;
							this.phone=res.data.data.mobile;
							this.adr=res.data.data.address;
			      }else{
				      this.$alert("<p>" + this.$t("prompt.againlogin") + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
	      		}
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
		//获取宠物列表组件信息
		getpetType(data){
		    this.selpetType = false;
		    this.petbelong = data.id;
		},
		//关闭简介
		introductClose(){
			this.isintroduction = false;
		},
		//展示简介
		showintroduct(){
			this.isintroduction = true;
		},
		//获取宠物品种
		selpetsType(isable){
			 isable = this.isable;
				if(isable == true){
					return false;
				}
		    this.selpetType = true;
		},
		//验证宠物品种
		Verificationbelong() {
		    console.log(this.petbelong)
		    if (this.petbelong=="") {
		        this.flag3 = false;
		        this.flag7 = true;
		    } else {
		        this.flag3 = false;
		        this.flag7 = false;
		    }
		},
		//改变种类
  	changepetbelong(e) {
      this.petType = e;
    },
    //改变名称
  	changename(e) {
      this.petname = e;
    },
    //验证宠物名称
    Verificationname() {
      if (this.petname.length > 0) {
        this.flag6 = false;
      }
    },
    //验证宠物品种
    Verificationbelong() {
      if (this.petType.length > 0) {
        this.flag7 = false;
      }
    },
		// 打开图片上传
    uploadHeadImg: function() {
        this.$el.querySelector(".hiddenInput").click();
    },   
    // 将头像显示
    handleFile: function(e) { 
      var th = this;
      th.imgflag = true;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
        Orientation = EXIF.getTag(this, "Orientation");
      });
      if (file) {
        reader.readAsDataURL(file);
      }
      th.changeflag = true;
      reader.onload = data => {
        let res = data.target || data.srcElement;
        if (data.total < maxSize) {
          th.showflag1 = false;
          th.isshow = true;
          th.avatar = res.result;
          th.portrait1 = data.target.result.split(",")[1];
          localStorage.setItem('portrait',th.portrait1)
        } else {
          th.compress(res.result, Orientation);
        }
      };               
    },
    //图片压缩
    compress(result, Orientation) {
      var img = new Image();
      var th = this;
      img.src = result;
      th.showflag1 = true;
      th.isshow = false;
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        var ratio = 400;
        if (width > ratio) {
          var scaling = 1 - (width - ratio) / width;
          width = width * scaling;
          height = height * scaling;
        }
        var canvas = th.$refs.can;
        var ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, width, -height);
              break;
            case 8: //需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((-90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, 0);
              break;
            case 3: //需要180度旋转
              ctx.rotate((180 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, -height);
              break;
          }
        } else {
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        }
        var base64 = canvas.toDataURL("image/jpeg", 1.5);
        th.portrait1 = base64.split(",")[1];
        th.avatar = base64.result;
      };
    },
//=====失去焦点返回顶部==== 
		lossblur(){
	    setTimeout(function() {
	        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
	       window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
		}
			
  },
  beforeUpdate() {

  },
  filters: {
    infosCmputed: function(value) {
      if (value == "TAG") return this.$t("prompt.QrCode");
    },
    lowercase: function(value) {
      return value.toLowerCase();
    }
  },
  components: {
    "v-header": header,
    "v-choosePet": choosePet,
    "v-introduction":introduction,
    adddeviceType,
    addpetType
  }
};
</script>
<style>
	.pet .el-input .el-input__inner{
  border: none;
  border-color:#fff !important;
  border-bottom: solid 1px #fff;
  width: 100%;
  box-sizing: border-box;
  text-align: center !important;
  height: 1.8rem !important;
  line-height: 1.8rem !important;
  padding: 0 0.5rem 0 1rem !important;
  font-size: 0.8rem;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
}
.pet .el-select,.pet .el-input{
  width: 100%;
	color: #fff;
}
.el-select .el-input .el-select__caret{
	color: #fff;
}
.el-input__icon{
	line-height: 30px;
}
.el-select .el-input .is-focus .el-input__inner{
	border-color:#fff;
}
.el-select:hover .el-input__inner {
    border-color: #fff;
}
.el-input__inner::-webkit-input-placeholder{
    color:#fff;
}
.el-input__inner:-moz-placeholder{
    color:#fff;
}
.el-input__inner::-moz-placeholder{
    color:#fff;
}
.el-input__inner:-ms-input-placeholder{
    color:#fff;
}
</style>
<style scoped>

.home {
  width: 100%;
  overflow-x: hidden;
}
.home .el-button--primary { /*激活按钮*/
    width: 72%;
    margin-left: 14%;
    font-size: 1.2rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}	
img {
  width: 100%;
}
.allinfo{
	width: 100%;
	height: 100%;
	min-height: 25rem;
	background: url(../../../static/img/mainbg.png) top center #fff no-repeat;
  background-size: 100% auto;
}
.title {
    padding-top: 1.5rem;
    padding-bottom: .5rem;
}
.title ul{
	position: relative;
}
.title ul li{
    text-align: center;
    color: #000;
    font-size: 1rem;
    font-family:PingFang SC;
}
.title ul p{
		text-align: right;
    color: #fff;
    font-size: .8rem;
    width: 20%;
    font-weight: bold;
    font-family: PingFang SC;
    height: 1rem;
    display: inline-block;
    position: absolute;
    right: 2%;
    top: -25px;
}
.title ul p img{
	    width: 1rem;
	    padding-right: 10%;
	    vertical-align: middle;
	    margin-top: -5px;
}

.device_content {
  padding: 10px;
}
.device_content .device_title,
.device_box {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 0.85rem;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}
.device_content .device_code,
.device_box .device_code {
  flex: 6;
  color: #3f3f3f;
}
.device_content .bind_pet,
.device_box .bind_pet {
  flex: 18;
  padding-left: 10px;
}
.device_box {
  padding: 10px 0;
}
.device_box .bind_pet {
  border-left: 1px solid #eee;
  display: flex;
}
.device_code img {
  width: 1.5rem;
  display: block;
  margin: 0 auto;
}
.device_code span {
  display: block;
  margin-top: 5px;
  font-size: 0.5rem;
  text-align: center;
}
.bind_pet img {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.bind_pet span {
  padding-left: 20px;
  color: #808080;
  font-size: 1rem;
  line-height: 65px;
}


.lossbtn{
    position: absolute;
    bottom: .5rem;
    right: 20px;
    text-align: center;
    height: 1.2rem;
    width: 4.5rem;
    line-height: 1.2rem;
    color: #fff;
    font-size: 0.7rem;
    border: solid 1px #fff;
    border-radius: .6rem;
}
.lostsign{
	width: 4.5rem;
	height: 4.5rem;
	position: absolute;
	top: -20px;
	right: 0;
	z-index: 22;
  transform: rotate(30deg);
}
.lostsign li{
    width: 4rem;
    height: 4rem;
		color: #e34139;
    font-size: .1rem;
    display: inline-block;
    position: absolute;
    top: .3rem;
    left: .2rem;
    text-align: center; 
    transform: rotateZ(155deg);
}
.lostsign li span { position: absolute; display: inline-block; left: 0; right: 0; top: 0; bottom: 0; text-transform: uppercase; transition: all 0.5s cubic-bezier(0, 0, 0, 1); }
.lostsign li span:nth-child(1){
transform: rotateZ(0deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(2){
transform: rotateZ(15deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(3){
transform: rotateZ(30deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(4){
transform: rotateZ(45deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(5){
transform: rotateZ(60deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(6){
transform: rotateZ(75deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(7){
transform: rotateZ(90deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(8){
transform: rotateZ(105deg) translate3d(0px, 0px, 0px);		
}
.lostsign li span:nth-child(9){
transform: rotateZ(120deg) translate3d(0px, 0px, 0px);		
}
.lostsign li span:nth-child(10){
transform: rotateZ(135deg) translate3d(0px, 0px, 0px);		
}
.lostsign img{
	width: 100%;
}
/*宠物信息*/
.petinfo {
  width: 100%;
  max-width: 579px;
  height: 165px;
  position: relative;
  margin-top: 7%;
}
.petinfo .danger {
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}

.petinfo-main {
  position: absolute;
  bottom: 0;
  width: 94%;
  height: 100%;
  margin: 0 3%;
  max-width: 579px;
  overflow: hidden;
  touch-action: none;
  background: #5dcfe5;
  border: solid 1px #f3f3f3;
	-webkit-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
	-moz-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
	box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
}
.petinfo-main:before{
	content: '';
	background:url(../../../static/img/petinfoline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
    top: 61%;
    left: 2%;
    height: 35%;
    width: 15%;
	transform: rotate(180deg);
}
.petinfo-main:after{
	content: '';
	background: url(../../../static/img/petinfoline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
		top: 5%;
    left: 83%;
    height: 69%;
    width: 15%;
}
.head_img {
    margin-top: 15%;
    margin-left: 5%;
    width: 4.5rem;
    height: 4.5rem;
    position: absolute;
    border: none;
    border-radius: 50%;
    overflow: hidden;
}
.head_img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.pet {
    width: 60%;
    position: absolute;
    top: 15px;
    right: 20px;
}
.pet ul{
  margin-top: 1rem;
}
.pet ul li{
  list-style: none;
  width: 100%;
  position: relative;
}
.petNewsIcon{
    position: absolute;
    font-size: .5rem;
    display: block;
    height: 1.8rem;
    line-height: 1.8rem;
    z-index: 999;
    color: #fff;
}
.petNewsIcon img{
  width: .9rem;
  vertical-align: middle;
  margin: 0 0.5rem;
      margin-left: 0;
}
.pet ul li p{
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    border-bottom: 1px solid #eaeef9;
    height: 1.8rem;
    line-height: 1.8rem;
    font-size: .8rem;
    color: #fff;
}

.pet .el-input .el-input__inner{
  border: none;
  border-color:#fff !important;
  border-bottom: solid 1px #fff;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  height: 1.8rem;
  line-height: 1.8rem;
  padding: 0 0.5rem 0 1rem;
  font-size: 0.8rem;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
}
.pet .el-select,.pet .el-input{
  width: 100%;
	color: #fff;
}
.el-select .el-input .el-select__caret{
	color: #fff;
}
.el-select .el-input .is-focus .el-input__inner{
	border-color:#fff;
}
.el-select:hover .el-input__inner {
    border-color: #fff;
}
.el-input__inner::-webkit-input-placeholder{
    color:#fff;
}
.el-input__inner:-moz-placeholder{
    color:#fff;
}
.el-input__inner::-moz-placeholder{
    color:#fff;
}
.el-input__inner:-ms-input-placeholder{
    color:#fff;
}



/*主人信息*/
.mynews .el-button--primary{
background-color: rgb(9,81,150);
border-color: rgb(9,81,150);
}
.sel {
  width: 75%;
  box-sizing: border-box;
  text-align: right;
}
.sel .el-input {
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: right;
}
.sel .el-input__inner {
  border-radius: 0;
  border: 0;
  font-size: 0.8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #3f3f3f;
  text-align: right;
  background: transparent;
}
.mynews{
    height: 165px;
    max-width: 579px;
    width: 94%;
    position: relative;
    margin: 0 3%;
    margin-top: 6%;
    z-index: 10;
    background: #96dae7;
    border: solid 1px #f3f3f3;
		-webkit-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
		-moz-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
		box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
}
.mynews:before{
	content: '';
	background:url(../../../static/img/mynewsline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
	top: 5%;
	left: 2%;
  height: 45%;
  width: 21%;
	transform: rotate(180deg);
}
.mynews:after{
	content: '';
	background:url(../../../static/img/mynewsline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
	top: 50%;
	left: 77%;
  height: 45%;
  width: 21%;
}


.new{
    height: 100%;
    width: 70%;
    position: absolute;
    right: 15%;
}

.news{
    width: 70%;
    position: absolute;
    top: 8%;
    right: 15%;
}
.news .pos {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
}
.pos input {
  width: 96%;
  border: 0px;
  box-sizing: border-box;
  height: 1.6rem;
  line-height: 1.6rem;
  font-size: 0.8rem;
  background: transparent;
  color: #fff;
  text-align: center;
  padding-left: 15%;
}
.pos input::-webkit-input-placeholder{
    color:#fff;
}
.pos input:-moz-placeholder{
    color:#fff;
}
.pos input::-moz-placeholder{
    color:#fff;
}
.pos input:-ms-input-placeholder{
    color:#fff;
}


.pos input:disabled {
  border-radius: 0;
  border: 0px;
  opacity: 1;
  text-align: center;
  color: #fff;
}
.pos input:focus,
.pos select:focus {
  outline: none;
}
.news span {
	position: absolute;
    font-size: .5rem;
    display: block;
    height: 1.6rem;
    line-height: 1.6rem;
    z-index: 999;
    color: #fff;
}
.news span img{
    width: .9rem;
    vertical-align: middle;
    margin: 0 0.5rem;
        margin-left: 0;
}
.denger{
  font-size: .625rem;
  margin-top: 5px;
  color: red;
}
.news .el-button {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  padding: 0 0;
}
.hiddenInput {
  display: none;
}

@media screen and (max-width: 321px) {
	.home .el-button--primary{
		margin: 3rem auto !important;
	}
	.petinfo{
		width: 100%;
    max-width: 579px;
    height: 145px;
    position: relative;
    margin-top: 4%;
	}
	.pet{
		top: 0;
	}
	.pet span{
	    font-size: 0.78rem !important;
	}
	.pet ul{
	  margin-top: 2rem;
	} 
	.title ul p{
		top: -15px;
	}
	.mynews{
		height: 145px;
		margin-top: 5%;
	}
	.news{
		top:10%;
	}
	.news span {
	  height: 1.6rem;
	  line-height: 1.6rem;
	}
	.pos input{
		height: 1.6rem;
	  line-height: 1.6rem;
	} 
	.lossbtn{
		bottom: 2rem;
	}
}
@media (min-width: 411px) and (max-width: 578px) {
	.petinfo{
		height: 180px;
	}
	.lossbtn{
		bottom: .5rem;
	}
	.mynews{
		height: 180px;
		margin-top: 5%;
	}	
	.head_img{
		margin-top: 10%;
	}
}
</style>




// WEBPACK FOOTER //
// src/m_page/home/activation.vue